module.exports = __webpack_public_path__ + "img/IconExternalLink.065fbc7b.svg";